module.exports = __webpack_public_path__ + "media/favicons/16x16-e648c226.png";